import { FeatureData } from '../../components/ui/feature-section-with-hoover-effect';
import {
  IconRocket,
  IconDatabase,
  IconScale,
  IconDeviceImac,
} from '@tabler/icons-react';

const appCloudFeatures: FeatureData[] = [
  {
    title: 'features.startups.title',
    description: 'features.startups.description',
    icon: <IconRocket size={24} />,
    key: 'features.startups'
  },
  {
    title: 'features.saasEditors.title',
    description: 'features.saasEditors.description',
    icon: <IconDatabase size={24} />,
    key: 'features.saasEditors'
  },
  {
    title: 'features.regulatedCompanies.title',
    description: 'features.regulatedCompanies.description',
    icon: <IconScale size={24} />,
    key: 'features.regulatedCompanies'
  },
  {
    title: 'features.mobileWebEditors.title',
    description: 'features.mobileWebEditors.description',
    icon: <IconDeviceImac size={24} />,
    key: 'features.mobileWebEditors'
  },
];

export default appCloudFeatures; 